<template>
  <el-row type="flex" justify="center">
    <el-col :xs="24" :md="12" :lg="8">
      <el-card class="login-form-container">
        <h3>Quên mật khẩu</h3>
        <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
        <br/>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          hide-required-asterisk
          @submit.native.prevent
          @keyup.enter.native.passive="onSubmit"
        >
          <el-form-item prop="email">
            <el-input v-model="form.email" placeholder="Email" />
          </el-form-item>

          <el-form-item class="el-col-6">
            <el-button ref="submitButton" type="primary" @click="onSubmit">
              Gửi
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { forgotPassword } from "@/services/authentication_service"

export default {
  name: "ForgotPassword",
  data() {
    return {
      form: {
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "Hãy nhập email đăng ký",
            trigger: "change",
          },
          {
            type: "email",
            message: "Hãy nhập chính xác địa chỉ email",
            trigger: "blur",
          },
        ],
      },
      errorMessage: null,
    }
  },
  created() {
    if (this.isAuthenticated) {
      console.log("Authenticated")
      this.onSuccessLogin()
    }
  },
  methods: {
    onSubmit() {
      this.errorMessage = null
      this.$refs.submitButton.loading = true
      this.$refs["form"].validate((valid) => {
        if (valid) {
          forgotPassword(
            this.form.email,
            this.onSuccess,
            this.onError,
            () => (this.$refs.submitButton.loading = false)
          )
        }
        this.$refs.submitButton.loading = false
      })
    },
    onSuccess() {
      this.$message({
        message: "Email xác nhận sẽ được gửi trong giây lát",
        type: "success",
      })
    },
    onError(message) {
      this.errorMessage = message
    },
  },
}
</script>

<style scoped>
.login-form-container {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 5px;
}

.error-message {
  margin-top: 2px;
  padding: 5px 5px 5px 10px;
  background-color: indianred;
  width: 100%;
  border-radius: 3px;
  color: white;
}
</style>
